// src/api/authAPI.js
import api from "./axiosConfig";

export const loginUser = async (credentials, setAccessToken) => {
  const response = await api.post("/login", credentials);
  const token = response.data?.accessToken ||
                response.data?.token || null;

  if (token && typeof setAccessToken === 'function') {
    setAccessToken(token);
  }

  const userData = response.data?.user || {
    id: response.data?._id,
    _id: response.data?._id,
    username: response.data?.username,
    role: response.data?.role,
    stores: response.data?.stores
  };
  if (userData) {
    localStorage.setItem("user", JSON.stringify(userData));
  }

  return response.data;
};

// Alias for backward compatibility
export const login = loginUser;

// Utility function to decode JWT token and get user ID
export const getUserIdFromToken = () => {
  const rawUser = localStorage.getItem('user');
  if (!rawUser) return null;

  try {
    const user = JSON.parse(rawUser);
    return user?.id || user?._id || null;
  } catch {
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('tenantId');
  localStorage.removeItem('storeId');
  localStorage.removeItem('accountingClientId');
  localStorage.removeItem('tenantType');
  localStorage.removeItem('contextKind');
  localStorage.removeItem('rememberMe');
  localStorage.removeItem('rememberedUsername');
};

export const getCurrentUser = async () => {
  const response = await api.get("/me"); // ✅
  return response.data;
};

export const getContextOptions = async () => {
  const response = await api.get("/context/options"); // ✅
  return response.data;
};
